import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import Notification from 'modules/Services/Notifications/Notification'
import { useCancelToken } from 'utils/hooks/useCancelToken'
import { FETCH_NETWORK_NOTIFICATIONS } from 'modules/Services/types'

const Notifications = ({ networkId, accountId = null, texts = [] }) => {
  const { cancelableDispatch } = useCancelToken()

  const { notifications, id } = useSelector((state) => ({
    ...state['services/network'],
  }))

  useEffect(() => {
    !!networkId &&
      cancelableDispatch({
        type: FETCH_NETWORK_NOTIFICATIONS,
        payload: { networkId, accountId },
      })
  }, [networkId])

  return (
    notifications.length > 0 &&
    notifications.map((notification, i) => (
      <Notification
        key={'net-notification-' + i}
        {...notification}
        networkId={id}
        texts={texts}
      />
    ))
  )
}

export default Notifications
